import { render, staticRenderFns } from "./BalanceBadge.vue?vue&type=template&id=13727c1a&"
import script from "./BalanceBadge.vue?vue&type=script&lang=js&"
export * from "./BalanceBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports